import axios from 'axios'

import { SHIPPER_GUIDE_API_URL } from 'core/infra/environment'

import http from 'legacy/utils/http'

export function getAccountV2() {
  return axios.get('/api/v2/account', http.getHeadersV2())
}

export async function resetAccountPassword(data) {
  return axios.post('/auth/carrier_password_reset', JSON.stringify(data), {
    baseURL: SHIPPER_GUIDE_API_URL,
    headers: { 'Content-Type': 'application/json' },
  })
}

export function verifyAccount(data) {
  return axios.post('/api/v2/account/verify', JSON.stringify(data), http.getPublicHeadersV2())
}
